export default __webpack_public_path__ + "locales/ja-JP/SmartBanner.json?hash=3d4119420dcdb6594c7fedf6df9de8f3";